import getNested from 'lodash-es/get'
import Vue from 'vue'
import Vuex from 'vuex'
import sortBy from "lodash-es/sortBy";


Vue.use(Vuex);

const baseUrl = process.env.VUE_APP_API_BETA + '/polygons';

export default {
  namespaced: true,
  modules: {
    // polygons: PolygonsStore,
  },

  state: () => {
    return {
      commodities: null,
    };
  },


  mutations: {
    setStateValue(state, {name, value}) {
      state[name] = value;
    },
  },

  actions: {
    async listPorts({dispatch}, parameters) {
      let response = await dispatch(
        'apiRequest',
        {
          method: 'get',
          path: '/ports',
          data: parameters,
        }
      );

      return response.data;
    },

    async listPortNameAliases({dispatch}, portId) {
      let response = await dispatch(
        'apiRequest',
        {
          method: 'get',
          path: `/port_name_aliases/${portId}`,
          data: undefined,
        }
      );

      let items = getNested(response, 'data.portNameAliases', []);
      return items.map(item => item.nameAlias);
    },

    async addPortNameAlias({dispatch}, {portId, name}) {
      let response = await dispatch(
        'apiRequest',
        {
          method: 'post',
          path: `/port_name_aliases`,
          data: {
            port_id: portId,
            name_alias: name,
          },
        }
      );

      if(response.error) {
        console.log('api error', response);
        return response;
      }

      return response.data || [];
    },

    async removePortNameAlias({dispatch}, {portId, name}) {
      let response = await dispatch(
        'apiRequest',
        {
          method: 'delete',
          path: `/port_name_aliases/${portId}/${name}`,
          data: undefined,
        }
      );

      if(response.error) {
        console.log('api error', response);
        return response;
      }

      return response.data || [];
    },

    async listPortUnlocodeAliases({dispatch}, portId) {
      let response = await dispatch(
        'apiRequest',
        {
          method: 'get',
          path: `/port_unlocode_aliases/${portId}`,
          data: undefined,
        }
      );

      let items = getNested(response, 'data.portUnlocodeAliases', []);
      return items.map(item => item.unlocode);
    },

    async addPortUnlocodeAlias({dispatch}, {portId, name}) {
      let response = await dispatch(
        'apiRequest',
        {
          method: 'post',
          path: `/port_unlocode_aliases`,
          data: {
            port_id: portId,
            unlocode: name,
          },
        }
      );

      if(response.error) {
        console.log('api error', response);
        return response;
      }

      return response.data || [];
    },

    async removePortUnlocodeAlias({dispatch}, {portId, name}) {
      let response = await dispatch(
        'apiRequest',
        {
          method: 'delete',
          path: `/port_unlocode_aliases/${portId}/${name}`,
          data: undefined,
        }
      );

      if(response.error) {
        console.log('api error', response);
        return response;
      }

      return response.data || [];
    },


    async getPort({dispatch}, portId) {
      let response = await dispatch(
        'apiRequest',
        {
          method: 'get',
          path: `/ports/${portId}`,
          data: undefined,
        }
      );

      if(response.error) {
        console.log('api error', response);
        return null;
      }

      return getNested(response, 'data.port', null);
    },

    async updatePort({dispatch}, data) {
      let response = await dispatch(
        'apiRequest',
        {
          method: 'put',
          path: `/ports`,
          data: data,
        }
      );

      if(response.error) {
        console.log('api error', response);
        return response;
      }

      return getNested(response, 'data.port', null);
    },

    async listPortBerths({dispatch}, portId) {
      let response = await dispatch(
        'apiRequest',
        {
          method: 'get',
          path: `/ports/${portId}/berths`,
          data: undefined,
        }
      );

      if(response.error) {
        console.log('api error', response);
        return null;
      }

      return getNested(response, 'data.berths', []);
    },

    async createBerth({dispatch}, data) {
      let response = await dispatch(
        'apiRequest',
        {
          method: 'post',
          path: `/ports/${data.portId}/berths`,
          data: data,
        }
      );

      if(response.error) {
        console.log('api error', response);
        return response;
      }

      return getNested(response, 'data', null);
    },

    async updateBerth({dispatch}, data) {
      let response = await dispatch(
        'apiRequest',
        {
          method: 'put',
          path: `/ports/${data.portId}/berths`,
          data: data,
        }
      );

      if(response.error) {
        console.log('api error', response);
        return response;
      }

      return getNested(response, 'data.berth', null);
    },

    async deleteBerth({dispatch}, data) {
      let response = await dispatch(
        'apiRequest',
        {
          method: 'delete',
          path: `/ports/${data.portId}/berths/${data.berthId}`,
          data: data,
        }
      );

      if(response.error) {
        console.log('api error', response);
        return response;
      }

      return getNested(response, 'data', null);
    },

    async listCommodities(store) {
      if(store.state.commodities) {
        return store.state.commodities;
      }

      let response = await store.dispatch(
        'apiRequest',
        {
          method: 'get',
          path: `/commodities`,
          data: undefined,
        }
      );

      if(response.error) {
        console.log('api error', response);
        return null;
      }

      let commodities = getNested(response, 'data.commodities', []);
      commodities = commodities.map(item => ({
        value: item.commodityId,
        text: item.commodityName,
        group: item.commoditySubgroup,
      }));

      commodities = sortBy(commodities, ['commodityName']);
      store.commit('setStateValue', {name: 'commodities', value: commodities});
      return commodities;
    },

    async listBerthCommodities({dispatch}, portId) {
      let response = await dispatch(
        'apiRequest',
        {
          method: 'get',
          path: `/commodity_mappings/${portId}`,
          data: undefined,
        }
      );

      if(response.error) {
        console.log('api error', response);
        return null;
      }

      return getNested(response, 'data.commodityMappings', []);
    },

    async addBerthCommodity({dispatch}, data) {
      let response = await dispatch(
        'apiRequest',
        {
          method: 'post',
          path: `/commodity_mappings`,
          data: data,
        }
      );

      if(response.error) {
        console.log('api error', response);
        return response;
      }

      return response.data;
    },

    async removeBerthCommodity({dispatch}, data) {
      /*
      berthId (required)
      commodityId (required)
      */

      let response = await dispatch(
        'apiRequest',
        {
          method: 'delete',
          path: `/commodity_mappings/${data.berthId}/${data.commodityId}/${data.flowDirection}`,
          data: undefined,
        }
      );

      if(response.error) {
        console.log('api error', response);
        return response;
      }

      return response.data;
    },

    async listPortShipyards({dispatch}, portId) {
      let response = await dispatch(
        'apiRequest',
        {
          method: 'get',
          path: `/ports/${portId}/shipyards`,
          data: undefined,
        }
      );

      if(response.error) {
        console.log('api error', response);
        return null;
      }

      return getNested(response, 'data.shipyards', []);
    },

    async updateShipyard({dispatch}, data) {
      let response = await dispatch(
        'apiRequest',
        {
          method: 'put',
          path: `/ports/${data.portId}/shipyards`,
          data: data,
        }
      );

      if(response.error) {
        console.log('api error', response);
        return response;
      }

      return getNested(response, 'data.shipyard', null);
    },


    async listPortAnchorages({dispatch}, portId) {
      let response = await dispatch(
        'apiRequest',
        {
          method: 'get',
          path: `/anchorage_mappings/${portId}`,
          data: undefined,
        }
      );

      if(response.error) {
        console.log('api error', response);
        return null;
      }

      return getNested(response, 'data.anchorageMappings', []);
    },

    async getAnchorage({dispatch}, anchorageId) {
      let response = await dispatch(
        'apiRequest',
        {
          method: 'get',
          path: `/anchorages/${anchorageId}`,
          data: undefined,
        }
      );

      if(response.error) {
        console.log('api error', response);
        return null;
      }

      return getNested(response, 'data.anchorage', null);
    },

    async updateAnchorage({dispatch}, data) {
      let response = await dispatch(
        'apiRequest',
        {
          method: 'put',
          path: `/anchorages`,
          data: data,
        }
      );

      if(response.error) {
        console.log('api error', response);
        return response;
      }

      return getNested(response, 'data.anchorage', null);
    },

    async listInAreaEntities({dispatch}, data) {
      // expected parameters
      // {
      // 	"lowerLeft": [130,33],
      // 	"upperRight": [132,35]
      // }

      let response = await dispatch(
        'apiRequest',
        {
          method: 'post',
          path: `/inarea`,
          data: data,
        }
      );

      if(response.error) {
        console.log('api error', response);
        return response;
      }

      return getNested(response, 'data.polygons', []);
    },

    async searchEntities({dispatch}, searchString) {
      // expected parameters
      // {q: 'text to search'}

      let response = await dispatch(
        'apiRequest',
        {
          method: 'get',
          path: `/search`,
          data: {
            q: searchString
          },
        }
      );

      if(response.error) {
        console.log('api error', response);
        return response;
      }

      return getNested(response, 'data', []);
    },

    async apiRequest(store, parameters) {
      // here you can override common API request parameters for this api module
      // for example:
      // parameters: {...parameters, baseUrl: process.env.VUE_APP_BETA_API_URL},
      return store.dispatch(
        'apiRequest',
        {...parameters, baseUrl},
        { root: true },
      );
    },
  }
}
